import React, { useState } from 'react';
import { topCasinos } from '../../mocks/casinos';

const RatingPage: React.FC = () => {
  const [selectedCasino, setSelectedCasino] = useState<number | null>(null);

  return (
    <div className="min-h-screen pt-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Рейтинг онлайн казино России 2026
          </h1>
          <p className="text-xl text-gray-600">
            Полный обзор лучших казино с рублевыми счетами и быстрыми выплатами
          </p>
        </div>

        <div className="space-y-6">
          {topCasinos.map((casino, index) => (
            <div
              key={casino.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 p-6">
                <div className="flex items-center gap-4">
                  <div className="text-4xl font-bold text-gray-300">#{index + 1}</div>
                  <div className={`${casino.bgColor} w-24 h-24 rounded-xl flex items-center justify-center overflow-hidden`}>
                    <img
                      src={casino.image}
                      alt={casino.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900">{casino.name}</h3>
                    <div className="flex items-center gap-1 mt-1">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={`ri-star-fill text-sm ${
                            i < Math.floor(casino.rating) ? 'text-yellow-400' : 'text-gray-300'
                          }`}
                        ></i>
                      ))}
                      <span className="text-sm text-gray-600 ml-1">{casino.rating}</span>
                    </div>
                  </div>
                </div>

                <div>
                  <p className="text-sm text-gray-600 mb-1">Бонус</p>
                  <p className="text-lg font-bold text-blue-600">{casino.bonus}</p>
                  <p className="text-sm text-gray-500 mt-1">Вейджер: {casino.wagerRequirement}</p>
                </div>

                <div>
                  <p className="text-sm text-gray-600 mb-1">Скорость вывода</p>
                  <p className="text-lg font-bold text-green-600">{casino.withdrawTime}</p>
                  <p className="text-sm text-gray-500 mt-1">Игр: {casino.games}</p>
                </div>

                <div className="flex flex-col gap-2">
                  <button className="w-full py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-medium hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                    Играть
                  </button>
                  <button
                    onClick={() => setSelectedCasino(selectedCasino === casino.id ? null : casino.id)}
                    className="w-full py-3 bg-gray-100 text-gray-900 rounded-full font-medium hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {selectedCasino === casino.id ? 'Скрыть детали' : 'Подробнее'}
                  </button>
                </div>
              </div>

              {selectedCasino === casino.id && (
                <div className="border-t border-gray-200 p-6 bg-gray-50">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">Лицензия</h4>
                      <p className="text-gray-600">{casino.license}</p>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">Минимальный депозит</h4>
                      <p className="text-gray-600">₽{casino.minDeposit}</p>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">Методы оплаты</h4>
                      <div className="flex flex-wrap gap-2">
                        {casino.paymentMethods.map((method, idx) => (
                          <span
                            key={idx}
                            className="text-xs px-2 py-1 bg-white rounded-full text-gray-700"
                          >
                            {method}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">Особенности</h4>
                      <div className="flex flex-wrap gap-2">
                        {casino.features.map((feature, idx) => (
                          <span
                            key={idx}
                            className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded-full"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RatingPage;